import React from 'react';
interface DashboardCardProps {
  title?: string;
  subtitle?: string;
  icon?: ReactNode;
  className?: string;
  children: ReactNode;
  footer?: ReactNode;
}
export function DashboardCard({
  title,
  subtitle,
  icon,
  children,
  className = '',
  footer
}: DashboardCardProps) {
  return <div className={`bg-gradient-to-br from-slate-800/90 to-blue-900/90 backdrop-blur-sm border border-white/10 rounded-xl overflow-hidden shadow-lg ${className}`} data-id="element-1180" data-mp="19swuy0twruff">
      {(title || icon) && <div className="p-5 border-b border-white/10 flex justify-between items-center" data-id="element-1181" data-mp="1it33d8ar247q">
          <div className="flex items-center" data-id="element-1182" data-mp="1iuxnwli3zuba">
            {icon && <div className="mr-3" data-id="element-1183" data-mp="1nthckto37k7c">{icon}</div>}
            <div data-id="element-1184" data-mp="1sr943mktl4b0">
              {title && <h2 className="text-lg font-bold text-white" data-id="element-1185" data-mp="1sriwfgtc7njv">{title}</h2>}
              {subtitle && <div className="text-sm text-blue-300" data-id="element-1186" data-mp="3pjswalfbrp7y">{subtitle}</div>}
            </div>
          </div>
        </div>}
      <div className="p-5" data-id="element-1187" data-mp="3uhudf0t6xegs">{children}</div>
      {footer && <div className="px-5 py-3 border-t border-white/10 bg-slate-900/50" data-id="element-1188" data-mp="3ukqcwtkosb7c">
          {footer}
        </div>}
    </div>;
}